import React, { useState, useContext } from "react";
import styled from "styled-components";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { db, auth } from '../../../firebase';
import firebase from "firebase";
import { useHistory } from "react-router";
import logo from "../../../assets/images/logos/logo.png";
import brand from "../../../assets/sx.png";
import google from '../../../assets/google.png';
import { userContext } from '../../../App';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
// import './SignInDialog.css';

import { makeStyles, withStyles } from "@material-ui/core/styles";
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import Button from '@material-ui/core/Button';
import Backdrop from '@material-ui/core/Backdrop';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    fontFamily: "Rubik"
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    paddingBottom: "48px",
    textAlign:"center",
    width: "500px",
    '@media (max-width: 560px)': {
      width: "320px",
    },
  },
  closeButton: {
    color: theme.palette.grey[500],
    display: "flex",
    marginLeft: "auto",
    justifyContent: "flex-end",
  },
  continue: {
    fontWeight: "normal", 
    position: "relative", 
    left: "75px",
    '@media (max-width: 560px)': {
      left: "15px",
    },
  }
}));


export default function SignInDialog(props) {
  let history = useHistory();
  const classes = useStyles();
  const { state, dispatch } = useContext(userContext);
  const Signin = () => {
    history.push("/signin");
  };
  const Signup = () => {
    history.push("/signup");
  };
  const handleClose = () => {
    if (props.from === 'Profile') {
      props.setopenDialog(false);
    }
    else {
      props.setnavClick(false);
    }
  };
  const handleGoogleAuthentication = async () => {
    var provider = new firebase.auth.GoogleAuthProvider();
    try {
      const data = await auth.signInWithPopup(provider);
      const res = db.collection('users').doc(auth.currentUser.uid);
      const follower = (await res.get()).data().follower;
      const follower_Count = (await res.get()).data().follower_Count;
      const saved = (await res.get()).data().saved;
      const userData = {
        uid: auth.currentUser.uid,
        email: auth.currentUser.email,
        name: auth.currentUser.displayName,
        follower: follower,
        follower_Count: follower_Count,
        saved: saved,
      };
      localStorage.setItem("user", JSON.stringify(userData));
      localStorage.setItem('allowed', '1');
      dispatch({ type: "USER_SIGNIN", payload: userData });
      console.log(data);
      handleClose();
      history.push("/home"); //Redirect to home after signed in sucessfully
    } catch (err) {
      console.log(err);
    }
  };
  return (
          <Modal
            open={props.open}
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={props.open}>
              <div className={classes.root}>
                <div className={classes.paper}>
                
                  <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                    <CloseIcon />
                  </IconButton>

                  <Title id="spring-modal-title">Join Friend a Book<br/>to use this feature</Title>
                  <span>Free access to all the Folios</span>

              
              <ButtonEmail  onClick={Signup}>Continue With Email</ButtonEmail>

              <GoogleButton onClick={handleGoogleAuthentication}>
                <span>
                  <Google />
                </span>
                <span className={classes.continue}>
                  Continue With Google
                </span>
              </GoogleButton>

              <Text>By continuing, you agree to Friend a Book's <Link href='/terms'>Terms of Service</Link> and acknowledge you've read our <Link href='/privacy'>Privacy Policy</Link></Text>

              <Linkto href='/signin'>Already a member? Sign In</Linkto>
       
                {/* <div className={classes.root} style={{ justifyContent: "space-evenly", marginTop: "20px" }}>
                  <ColorButton variant="contained" style={{ background: "#5db0d8" }}>
                    Continue with Email
                  </ColorButton>
                  <ColorButton variant="contained" color="secondary" onClick={() => { handleClose() }}>No</ColorButton>
                </div> */}
                </div>
              </div>
            </Fade>
          </Modal>    
  );
}

const Title = styled.h1`
  font-size: 32px;
  @media (max-width: 560px){
    font-size: 28px;
  },
`

const ButtonEmail = styled.button`
  border-radius: 31.55px;
  background: rgb(230, 0, 35);
  font-family: Rubik;
  font-size: 17px;
  font-weight: 500;
  color: white;
  border: none;
  height: 45px;
  width: 400px;
  padding: 9.3px 16.456px;
  margin: 30px auto 10px;
  cursor: pointer;
  text-align: center;
  @media (max-width: 560px){
    font-size: 15px;
    height: 40px;
    width: 250px;
  },
`;

const GoogleButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 31.55px;
  text-align: center;
  background: #3e6ae1;
  font-size: 17px;
  font-weight: 500;
  color: white;
  border: none;
  height: 45px;
  width: 400px;
  padding: 9.3px 16.456px 9.3px 0.5px;
  cursor: pointer;
  margin: auto;
  @media (max-width: 560px){
    font-size: 15px;
    height: 40px;
    width: 250px;
  },
`;

const Google = styled.img.attrs({
  src: google,
})`
  float: left;
  height: 43px;
  width: 43px;
  @media (max-width: 560px){
    height: 40px;
    width: 40px;
  },
`;

const Text = styled.p`
  font-size: 12px;
  margin: 10px auto 30px;
  width: 400px;
  &:hover{
    cursor: default;
    }
    @media (max-width: 560px){
      width: 250px;
    },
`

const Link = styled.a`
  color: blue;
  cursor: pointer;
  &:hover{
  cursor: pointer;
  }
`

const Linkto = styled.a`
  font-size: 12px;
  color: black;
  font-weight: 900; 
  margin: 30px auto 48px;
  cursor: pointer;
  &:hover{
  cursor: pointer;
  color: black;
  }
`























// import React, { useState, useContext } from "react";
// import Modal from "react-bootstrap/Modal";
// import styled from "styled-components";
// import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
// import { db, auth } from '../../../firebase';
// import firebase from "firebase";
// import { useHistory } from "react-router";
// import logo from "../../../assets/images/logos/logo.png";
// import brand from "../../../assets/sx.png";
// import google from '../../../assets/google.png';
// import { userContext } from '../../../App';
// import CloseIcon from '@material-ui/icons/Close';
// import './SignInDialog.css';

// export default function SignInDialog(props) {
//   let history = useHistory();
//   const { state, dispatch } = useContext(userContext);
//   const Signin = () => {
//     history.push("/signin");
//   };
//   const Signup = () => {
//     history.push("/signup");
//   };
//   const handleClose = () => {
//     if (props.from === 'Profile') {
//       props.setopenDialog(false);
//     }
//     else {
//       props.setnavClick(false);
//     }
//   };
//   const handleGoogleAuthentication = async () => {
//     var provider = new firebase.auth.GoogleAuthProvider();
//     try {
//       const data = await auth.signInWithPopup(provider);
//       const res = db.collection('users').doc(auth.currentUser.uid);
//       const follower = (await res.get()).data().follower;
//       const follower_Count = (await res.get()).data().follower_Count;
//       const saved = (await res.get()).data().saved;
//       const userData = {
//         uid: auth.currentUser.uid,
//         email: auth.currentUser.email,
//         name: auth.currentUser.displayName,
//         follower: follower,
//         follower_Count: follower_Count,
//         saved: saved,
//       };
//       localStorage.setItem("user", JSON.stringify(userData));
//       localStorage.setItem('allowed', '1');
//       dispatch({ type: "USER_SIGNIN", payload: userData });
//       console.log(data);
//       handleClose();
//       history.push("/home"); //Redirect to home after signed in sucessfully
//     } catch (err) {
//       console.log(err);
//     }
//   };
//   return (
//     <div>
//       <Modal
//         show={props.open}
//         onHide={handleClose}
//         style={{ marginTop: "18vh" }}
//       >
//         <CloseIcon className='closeicon' onClick={handleClose} />
//         <Modal.Header className='header' style={{ paddingTop: "25vh", paddingBottom: "36vh" }}>
//           {/* <img
//             src={logo}
//             style={{
//               width: "5vw",
//               height: "10vh",
//               marginTop: "-22vh",
//               marginLeft: "14.5vw",
//               position: "absolute",
//             }}
//           />
//           <img
//             src={brand}
//             style={{
//               position: "absolute",
//               height: "4vh",
//               width: "10vw",
//               marginTop: "-10vh",
//               marginLeft: "12vw",
//             }}
//           /> */}
//           {/* <ErrorOutlineIcon fontSize="large" style={{position: 'absolute', marginTop: '-4vh', marginLeft: '15vw'}} />
//           <Modal.Title style={{ marginRight: "13vw" }}>
//             {" "}
//             You are not signed in!
//           </Modal.Title> */}
//           <h2 className='join' style={{ fontFamily: 'Rubik' }}>Join Friend a Book</h2>
//           <h2 className='use' style={{ fontFamily: 'Rubik' }}>to use this feature</h2>
//           <p className='free' style={{ fontFamily: 'Rubik' }}>Free access to all the Folios</p>
//           <ButtonEmail className='buttonemail' onClick={Signup}><span>Continue with Email</span></ButtonEmail>
//           <GoogleButton className='buttongoogle' onClick={handleGoogleAuthentication}>
//             <span>
//               <Google />
//             </span>
//             <span
//               className='googlespan'
//               style={{
//                 fontFamily: "Rubik",
//               }}
//             >
//               Continue With Google
//             </span>
//           </GoogleButton>
//           <p className='by' style={{ fontFamily: 'Rubik' }}>By continuing, you agree to Friend a Book's</p>
//           <p className='terms' style={{ fontFamily: 'Rubik' }}><a href='/terms' style={{ color: 'blue', cursor: 'pointer' }}>Terms of Service</a> and acknowledge you've read</p>
//           <p className='our' style={{ fontFamily: 'Rubik' }}>our <a href='/privacy' style={{ color: 'blue', cursor: 'pointer' }}>Privacy Policy</a></p>
//           <p className='already' style={{ fontFamily: 'Rubik' }}><span>Already a member?</span><span onClick={Signin} style={{ marginLeft: '0.4vw', cursor: 'pointer' }}>Sign In</span></p>
//         </Modal.Header>
//         {/* <Modal.Body style={{ padding: "10px" }}>
//           <div class="alert alert-danger" role="alert">
//             Please Sign In to use this feature
//           </div>
//           <div style={{ marginLeft: "16vw" }}>
//             <Button
//               variant="outlined"
//               onClick={handleClose}
//               style={{ marginRight: "1.5vw" }}
//             >
//               Close
//             </Button>

//             <Button variant="outlined" color="primary" onClick={Signin}>
//               Sign In
//             </Button>
//           </div>
//         </Modal.Body> */}

//         {/* <Modal.Footer> */}
//         {/* <Button variant="secondary" onClick={handleClose}>
//             Close
//           </Button>
          
//           <Button variant="primary" onClick={Signin}>
//             Sign In
//           </Button> */}
//         {/* </Modal.Footer> */}
//       </Modal>
//     </div>
//   );
// }

// const ButtonEmail = styled.button`
//   margin-top: 2vh;
//   color: white;
//   font-weight: 500;
//   border: none;
//   // width: 20vw;
//   height: 6vh;
//   background: #e60023;
//   border-radius: 31.35px;
//   font-size: 15px;
//   font-family: Rubik;
// `;

// const GoogleButton = styled.button`
//   display: flex;
//   margin-top: 10vh;
//   flex-direction: row;
//   align-items: center;
//   border-radius: 31.55px;
//   background: #3e6ae1;
//   font-weight: 500;
//   color: white;
//   border: none;
//   // width: 20vw;
//   cursor: pointer;
//   font-size: 15px;
// `;

// const Google = styled.img.attrs({
//   src: google,
// })`
//   height: 6vh;
//   width: 3vw;
//   position: relative;
// `;